<template>
  <div ref="el" class="dropzone">
    <div class="dz-message" data-dz-message>
      <span>{{msg}}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "underscore"

export default {
  data: function() {
    return {};
  },
  props: [
    "url",
    "fileSlot",
    "maxFiles",
    "acceptTypes",
    "maxSize",
    "existingFiles",
    "msg"
  ],
  mounted: function() {
    var me = this;
    me.dropzone = new Dropzone(this.$refs.el, {
      url: this.url,
      maxFilesize: this.maxSize,
      thumbnailWidth: 240,
      thumbnailHeight: null,
      maxFiles: this.maxFiles,
      method: "put",
      addRemoveLinks: true,
      acceptedFiles: this.acceptTypes,
      init: function() {
        this.addCustomFile = function(file, thumbnail_url, responce) {
          // Push file to collection
          this.files.push(file);
          // Emulate event to create interface
          this.emit("addedfile", file);
          // Add thumbnail url
          this.emit("thumbnail", file, thumbnail_url);
          // Add status processing to file
          this.emit("processing", file);
          // Add status success to file AND RUN EVENT success from responce
          this.emit("success", file, responce, false);
          // Add status complete to file
          this.emit("complete", file);
        };
      },
      removeFile: function() {
        me.emit("clear");
      }
    });
    
    if(me.existingFiles && me.existingFiles.length){
        _.each(me.existingFiles,function(item){
            me.dropzone.addCustomFile({
                processing: true,
                accepted: true,
                name: item.name,
                size: item.size || 0,
                type: "image/jpeg",
                status: Dropzone.SUCCESS
              },
              item.thumbnail,
              {
                status: "success"
              });
        })
    }

    this.dropzone.on("success", function(a, resp) {
      me.$emit("success", resp);
    });
    this.dropzone.on("processing", function(file) {
      var s = me.fileSlot || "";
      var u = me.url || "";
      u = u[u.length - 1] === "/" ? u : u + "/";
      this.options.url = u + s;
      if (!this.options.headers) this.options.headers = {};

      this.options.headers.authorization = "Bearer " + me.identity.token;
    });
  },
  computed: {
    ...mapState("config", ["identity"])
  },
  watch: {
    existingFiles: {
      handler: function(nv) {
        console.log(nv);
        if (nv) {
            var me=this;
         _.each(nv,function(item) {
            me.dropzone.addCustomFile(
              {
                processing: true,
                accepted: true,
                name: item.name,
                size: item.size || 0,
                type: "image/jpeg",
                status: Dropzone.SUCCESS
              },
              item.thumbnail,
              {
                status: "success"
              }
            );
          });
        }
      }
    }
  }
};
</script>

